import { render, staticRenderFns } from "./Devolucao.vue?vue&type=template&id=2c659b1e&"
import script from "./Devolucao.vue?vue&type=script&lang=js&"
export * from "./Devolucao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports